import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import noImage from "../../assets/images/image-not-available.jpg";
import { useApp } from "../../context/AppContextProvider";
import { enviroment } from "../../enviroment";
import ApiService from "../../services/ApiService";
import styles from "./CategoryShop.module.css";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import { Pagination } from "swiper/modules";

export default function CategoryShop() {
  const [shopCategory, setShopCategory] = useState([]);
  const navigate = useNavigate();
  const appData = useApp();

  const setNoImage = (e) => {
    e.target.src = noImage;
  };

  const getCategoryProd = (name, name_url) => {
    navigate(`/store/${name_url}`);
  };

  useEffect(() => {
    const payload = {
      store_id: parseInt(enviroment.STORE_ID),
    };
    ApiService.StoreCategory(payload)
      .then((res) => {
        setShopCategory(res?.payload_verticalList?.vertical || []);
      })
      .catch((err) => { });
  }, []);

  const validCategories = shopCategory?.filter(
    (item) => item && item?.name && item?.name_url
  ) || [];

  return (
    <div className={`container-fluid pb-0 ${styles.categoryContainer}`}>
      {validCategories.length > 0 && (
        <div className="container">
          <h1 className={`text-start ${styles.sectionTitle} m-0 p-0`}>
            Shop By Category
          </h1>
          <Swiper
            spaceBetween={15}
            slidesPerView={1.5}
            pagination={{ clickable: true }}
            modules={[Pagination]}
            className={styles.swiperContainer}
          >
            {validCategories.map((item, index) => (
              <SwiperSlide key={index} className="pt-4 pb-0">
                <div
                  className={`${styles.categoryCard}`}
                  onClick={() => getCategoryProd(item.name, item.name_url)}
                >
                  <div className={styles.imageWrapper}>
                    <img
                      src={item.image}
                      onError={setNoImage}
                      alt={item.name}
                      className={styles.categoryImage}
                    />
                  </div>
                </div>
                <p className={`${styles.categoryName} m-0 mt-2 p-0`}>
                  {item.name}
                </p>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      )}
    </div>
  );
}